import React from 'react'

import ChangeUserDropdown from './ChangeUserDropdown'

export default class ChangeUserButton extends React.PureComponent {
  state = { open: false }

  openDropdown = () => this.setState({ open: true })
  closeDropdown = () => this.setState({ open: false })

  render() {
    const { open } = this.state
    const trigger = (
      <button className="ui basic button" onClick={this.openDropdown}>
        Change User
      </button>
    )

    return (
      <ChangeUserDropdown
        open={open}
        key="change-user"
        direction="left"
        onClose={this.closeDropdown}
        trigger={trigger}
      />
    )
  }
}
